import { RECEIVED_PORTFOLIO } from './PortfolioActions';

export const portfolioReducer = (state = {}, action) => {
    if (action.type === RECEIVED_PORTFOLIO) {
      return action.portfolio.portfolio;
    }
    return state;
}
